import {request} from '@umijs/max';

export async function findOne(params) {
  return request('/api/dictItem/findOne', {
    params,
  });
}

export async function find(params) {
  return request('/api/dictItem/find', {
    params,
  });
}
export async function remove(params) {
  return request('/api/dictItem/delete', {
    method: 'POST',
    data: { ...params, method: 'delete' },
  });
}
export async function saveOrUpdate(params) {
  return request('/api/dictItem/saveOrUpdate', {
    method: 'POST',
    data: { ...params, method: 'post' },
  });
}

export async function selectDictItem(code,systemFlag:'N') {
  return request('/api/dictItem/select/'+code, {
    params:{systemFlag:systemFlag}
  });
}

export async function findDictItem(params) {
  return request('/api/dictItem/find', {
    params,
  });
}
